<span class="hover-target"
      [ngbPopover]="tooltipText"
      triggers="mouseenter:mouseleave"
      container="body"
      placement="top"
      popoverClass="custom-popover text-center">
    <ng-content></ng-content>
</span>
